// locales/en.json
var en_default = {
  "city.aarhus": "Aarhus",
  "city.amsterdam": "Amsterdam",
  "city.ankara": "Ankara",
  "city.antwerp": "Antwerp",
  "city.athens": "Athens",
  "city.barcelona": "Barcelona",
  "city.belgrade": "Belgrade",
  "city.bergen": "Bergen",
  "city.berlin": "Berlin",
  "city.bern": "Bern",
  "city.bordeaux": "Bordeaux",
  "city.bratislava": "Bratislava",
  "city.brno": "Brno",
  "city.brussels": "Brussels",
  "city.bucharest": "Bucharest",
  "city.budapest": "Budapest",
  "city.chisinau": "Chi\u0219in\u0103u",
  "city.cluj": "Cluj",
  "city.copenhagen": "Copenhagen",
  "city.cork": "Cork",
  "city.crimea": "Crimea",
  "city.debrecen": "Debrecen",
  "city.donetsk": "Donetsk",
  "city.dublin": "Dublin",
  "city.eastwatch": "Eastwatch",
  "city.edinburgh": "Edinburgh",
  "city.frankfurt": "Frankfurt",
  "city.gdansk": "Gda\u0144sk",
  "city.goldmere": "Goldmere",
  "city.gothenburg": "Gothenburg",
  "city.hamburg": "Hamburg",
  "city.helsinki": "Helsinki",
  "city.irondale": "Irondale",
  "city.istanbul": "Istanbul",
  "city.izmir": "Izmir",
  "city.kaliningrad": "Kaliningrad",
  "city.krakow": "Krak\xF3w",
  "city.kyiv": "Kyiv",
  "city.lisbon": "Lisbon",
  "city.ljubljana": "Ljubljana",
  "city.london": "London",
  "city.lviv": "Lviv",
  "city.lyon": "Lyon",
  "city.madrid": "Madrid",
  "city.malmo": "Malm\xF6",
  "city.manchester": "Manchester",
  "city.marseille": "Marseille",
  "city.milan": "Milan",
  "city.minsk": "Minsk",
  "city.moscow": "Moscow",
  "city.munich": "Munich",
  "city.naples": "Naples",
  "city.nicosia": "Nicosia",
  "city.north-nicosia": "North Nicosia",
  "city.northhaven": "Northhaven",
  "city.odesa": "Odesa",
  "city.oslo": "Oslo",
  "city.paris": "Paris",
  "city.patras": "Patras",
  "city.podgorica": "Podgorica",
  "city.porto": "Porto",
  "city.prague": "Prague",
  "city.pristina": "Pristina",
  "city.riga": "Riga",
  "city.rome": "Rome",
  "city.rostov": "Rostov-on-Don",
  "city.rotterdam": "Rotterdam",
  "city.salzburg": "Salzburg",
  "city.sarajevo": "Sarajevo",
  "city.seville": "Seville",
  "city.skopje": "Skopje",
  "city.sofia": "Sofia",
  "city.split": "Split",
  "city.st-petersburg": "St. Petersburg",
  "city.stockholm": "Stockholm",
  "city.stonegate": "Stonegate",
  "city.suncliff": "Suncliff",
  "city.tallinn": "Tallinn",
  "city.thessaloniki": "Thessaloniki",
  "city.tirana": "Tirana",
  "city.trondheim": "Trondheim",
  "city.varna": "Varna",
  "city.venice": "Venice",
  "city.vienna": "Vienna",
  "city.vilnius": "Vilnius",
  "city.warsaw": "Warsaw",
  "city.zagreb": "Zagreb",
  "city.zurich": "Z\xFCrich",
  "country.albania": "Albania",
  "country.austria": "Austria",
  "country.belarus": "Belarus",
  "country.belgium": "Belgium",
  "country.bosnia-and-herzegovina": "Bosnia and Herzegovina",
  "country.bulgaria": "Bulgaria",
  "country.croatia": "Croatia",
  "country.cyprus": "Cyprus",
  "country.czechia": "Czechia",
  "country.denmark": "Denmark",
  "country.estonia": "Estonia",
  "country.finland": "Finland",
  "country.france": "France",
  "country.germany": "Germany",
  "country.greece": "Greece",
  "country.hungary": "Hungary",
  "country.ireland": "Ireland",
  "country.ironvale": "Ironvale",
  "country.italy": "Italy",
  "country.kosovo": "Kosovo",
  "country.latvia": "Latvia",
  "country.lithuania": "Lithuania",
  "country.moldova": "Moldova",
  "country.montenegro": "Montenegro",
  "country.netherlands": "Netherlands",
  "country.north-macedonia": "North Macedonia",
  "country.northern-cyprus": "Northern Cyprus",
  "country.northreach": "Northreach",
  "country.norway": "Norway",
  "country.poland": "Poland",
  "country.portugal": "Portugal",
  "country.romania": "Romania",
  "country.russia": "Russia",
  "country.serbia": "Serbia",
  "country.slovakia": "Slovakia",
  "country.slovenia": "Slovenia",
  "country.spain": "Spain",
  "country.suncoast": "Suncoast",
  "country.sweden": "Sweden",
  "country.switzerland": "Switzerland",
  "country.turkey": "Turkey",
  "country.ukraine": "Ukraine",
  "country.united-kingdom": "United Kingdom",
  "difficulty.easy": "Forgiving",
  "difficulty.hard": "Challenging",
  "difficulty.medium": "Medium",
  "map.europeStandard.description": "An 82-territory Europe map derived from real province boundaries for 1\u201340 players.",
  "map.europeStandard.name": "Europe Standard",
  "map.testMini.description": "A synthetic six-province verification map.",
  "map.testMini.name": "Test Mini",
  "politics.defensiveCoordination.body": "Land defense beside allied territory increases 10% for three turns.",
  "politics.defensiveCoordination.title": "Defensive Coordination",
  "politics.economicReform.body": "Development purchases cost 15% less for three turns.",
  "politics.economicReform.title": "Economic Reform",
  "politics.emergencyReserves.body": "Add 2 Population to the controlled capital or best fallback city.",
  "politics.emergencyReserves.title": "Emergency Reserves",
  "politics.mobilization.body": "Infantry production costs 20% less for three turns.",
  "politics.mobilization.title": "Mobilization",
  "politics.nationalDefence.body": "Add one Fortress level to a selected controlled border city.",
  "politics.nationalDefence.title": "National Defence",
  "politics.peaceDividend.body": "National income increases 10% for one turn.",
  "politics.peaceDividend.title": "Peace Dividend",
  "politics.reconstruction.body": "Restore one bombardment-damaged Development in a selected city.",
  "politics.reconstruction.title": "Reconstruction",
  "politics.warEconomy.body": "Heavy units cost 10% less, but national income falls 10%.",
  "politics.warEconomy.title": "War Economy",
  "sea.adriatic-sea": "Adriatic Sea",
  "sea.aegean-sea": "Aegean Sea",
  "sea.atlantic": "Atlantic",
  "sea.baltic-sea": "Baltic Sea",
  "sea.black-sea": "Black Sea",
  "sea.irish-sea": "Irish Sea",
  "sea.north-sea": "North Sea",
  "sea.regional-waters": "Regional waters",
  "sea.southSea": "South Sea",
  "sea.western-mediterranean": "Western Mediterranean"
};

// src/english.ts
var englishMessages = Object.freeze(en_default);

export {
  englishMessages
};
